export { default as Stockreceipt } from './stockreceipt';
export { default as StockReceiptInsert } from './StockReceiptInsert';
export { default as StockReceiptUpdate } from './StockReceiptUpdate';
